import DeviceManagementContainer from './DeviceManagementContainer'

export default DeviceManagementContainer
